import { useCallback } from "react";

import { useMutation } from "@apollo/client";

import { type ApolloResult } from "../../shared/models";
import {
    type DeleteRemoteApiSpecMutation,
    type DeleteRemoteApiSpecMutationVariables,
    deleteRemoteApiSpec,
} from "../api/graphql";

export const useDeleteRemoteApiSpec = (): ApolloResult<{
    deleteRemoteApiSpec: (specId: string) => Promise<void>;
}> => {
    const [deleteSpec, { error, loading }] = useMutation<
        DeleteRemoteApiSpecMutation,
        DeleteRemoteApiSpecMutationVariables
    >(deleteRemoteApiSpec, {
        refetchQueries: ["getRemoteApiSpecs"],
    });

    const performDeleteSpec = useCallback(
        async (specId: string) => {
            await deleteSpec({
                variables: { specId },
            });
        },
        [deleteSpec],
    );

    return { deleteRemoteApiSpec: performDeleteSpec, error, loading };
};
